// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

#sticker-upload-dialog {
  display: flex;
  width: 83.6rem;
  height: 53.2rem;
}
#sticker-upload-dialog #upload-form {
  width: 50%;
  padding-top: 66px;
}
#sticker-upload-dialog #upload-form #sticker-dropzone {
  width: 32.7rem !important;
  height: 31.9rem !important;
  margin: auto;
}
#sticker-upload-dialog #uploads {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: rgb(251, 251, 251);
  padding-left: 20px;
}
#sticker-upload-dialog #uploads .scroll-guard {
  margin-top: 66px;
  margin-bottom: 66px;
  overflow-y: auto;
}
#sticker-upload-dialog .action-buttons #done-button {
  margin-right: 16px;
}
#sticker-upload-dialog .action-buttons #add-tags-button {
  padding: 8px 16px;
  border-radius: 6px;
  background-color: #ab3a72;
  color: white;
}
#sticker-upload-dialog .action-buttons #add-tags-button.disabled {
  background-color: lightgrey;
  color: #696969;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/Stickers/UploadStickersModal/StickerUploadDialog.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAAA;EAIE,aAAA;EACA,cAAA;EACA,eAAA;AAAF;AAEE;EACE,UAAA;EACA,iBATY;AAShB;AAEI;EACE,yBAAA;EACA,0BAAA;EACA,YAAA;AAAN;AAIE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;AAFJ;AAII;EACE,gBA1BU;EA2BV,mBA1Ba;EA2Bb,gBAAA;AAFN;AAOI;EACE,kBAAA;AALN;AAQI;EACE,iBAAA;EACA,kBAAA;EACA,yBDpBI;ECqBJ,YAAA;AANN;AAQM;EACE,2BAAA;EACA,cD7CQ;ACuChB","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n\n#sticker-upload-dialog {\n  $top-padding: 66px;\n  $bottom-padding: 66px;\n\n  display: flex;\n  width: 83.6rem;\n  height: 53.2rem;\n\n  #upload-form {\n    width: 50%;\n    padding-top: $top-padding;\n\n    #sticker-dropzone {\n      width: 32.7rem !important;\n      height: 31.9rem !important;\n      margin: auto;\n    }\n  }\n\n  #uploads {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    background-color: rgb(251, 251, 251);\n    padding-left: 20px;\n\n    .scroll-guard {\n      margin-top: $top-padding;\n      margin-bottom: $bottom-padding;\n      overflow-y: auto;\n    }\n  }\n\n  .action-buttons {\n    #done-button {\n      margin-right: 16px;\n    }\n\n    #add-tags-button {\n      padding: 8px 16px;\n      border-radius: 6px;\n      background-color: $magenta;\n      color: white;\n\n      &.disabled {\n        background-color: lightgrey;\n        color: $darkTextColor;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
